import React, { useEffect } from "react";
import { Button, Input, Table, message, Select, Upload, Switch } from "antd";
import { YhBox } from "@/components/YhBox";
import { useWarehouseModel } from "../../warehouseModel";
import { IVRMshelfDetail } from "../../warehouseTypes";
import { ColumnsType } from "antd/es/table";
import { warehouseService } from "../../warehouseService";
import { ShelfDrawer } from "./ShelfDrawer";
import { importPropsConfig,messageConfig } from "@/utils/importFile";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import useGlobalModel from "@/model/globalModel";
import { momentFormat } from "@/utils/utils";


//货位
export const ShelfTable = () => {
    const { setLoadingInfo } = useGlobalModel();
    const {
        shelfPgCfg, shelfDataSource, setSelectedShelfRows,
        selectedShelfRows, shelfLoadData, 
        shelfSearch, setShelfSearch, resetShelf,
        downloadTplShelf,
        setIShelfDrawer,editFormVal,exportWarehouseData,loadData
    } = useWarehouseModel();

    useEffect(() => {
        if (editFormVal.id) {
        shelfLoadData({ pageNum: 1, pageSize: 15 });
    }
    }, [editFormVal])
    const upLoadCallback = (retData:any) => {
        if (!retData) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
            // return message.warning("数据异常，请尝试重新导入")
        }
        let str: string = "";
        let total:number=0
        let num:number=0
        // retData?.forEach((item:any) => {
        //     total+=1
        //     if(item.msg!=='导入成功!'){
        //     num+=1
        //    str+=item.msg}
        // })
        // messageConfig(str? "共导入"+total+"条，"+num+"条未成功，以下配件导入异常：" + str : "共导入"+total+"条，"+num+"条未成功，导入成功", 20, "info");
        // messageConfig(retData, 20, "info");
        setLoadingInfo({ loadingVisible: false, txt: "" });
        shelfLoadData()
    }

    
    const action = <div className="flex justify-between white-space">
        <div>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_DATA_W_EDD_SHELF_AD}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => setIShelfDrawer("add")}
                >新增</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ASSETSA_DATA_W_EDD_SHELF_ED}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => {
                        if (selectedShelfRows.length !== 1) {
                            message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！");
                            return;
                        }
                        setIShelfDrawer("edit");
                    }}
                >编辑</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ASSETS_DATA_W_ED_SHELF_IM}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/assets/base/warehouse/shelf/import`, upLoadCallback, () => setLoadingInfo({ loadingVisible: true, txt: "正在导入中" }),false)}>
                    <Button className="mr-5" type="link" shape="round">导入</Button>
                </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.ASSETS_DATA_W_ED_SHELF_DLOAD}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => { downloadTplShelf() }}
            >下载模板</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_DATA_W_ED_SHELF_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={() => exportWarehouseData()}
            >货位导出</Button>
            </YhAuth>
        </div>
        <div className="flex min-width-select">
            <Input
            size="small"
                allowClear
                className="border-r-8 ml-10"
                placeholder="货位编码"
                value={shelfSearch?.["code"]}
                onChange={(e) => setShelfSearch({ ...shelfSearch, code: e.target.value }) }
                onBlur={(e) => setShelfSearch({ ...shelfSearch, code:e.target.value?.trim() }) }
            // onPressEnter={aeraFilter}
            />
            <Button
                style={{ margin: "0px 12px 0px 15px" }}
                shape="round"
                type="link"
                onClick={() => shelfLoadData()}
            >检索</Button>
            <Button
                style={{ margin: "0px 0px 0px 12px" }}
                shape="round"
                type="link"
                onClick={() => resetShelf()}
            >重置</Button>

        </div>
    </div>;
    const handleChangeStatus = async (status: boolean, id: string) => {
        let result
        if (status) {
            result = await warehouseService.enable({ 
                id:id,
                enable:"1" 
        })
        } else {
            result = await warehouseService.enable({ 
                id:id,
                enable:"0" 
            })
        }
        if (result.success) {
            message.success('操作成功！')
            if (editFormVal.id) {
                shelfLoadData({ pageNum: 1, pageSize: 15 });
            }
        } else {
            message.error('操作失败！')
        }
    }
    const columns: ColumnsType<IVRMshelfDetail> = [
        {
            title: '序号',
            width: 60,
            align: "center",
            render: (t, r, i) => <>{i + 1}</>
        },
        {
            title: '货位编号',
            width: 300,
            dataIndex: 'code',
        },
        {
            title: '所属仓库',
            width: 300,
            dataIndex: 'warehouseName',
        },
        {
            title: '创建人',
            width: 300,
            align: "center",
            dataIndex: 'createUser',
        },
        {
            title: '创建时间',
            width: 350,
            align: "center",
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        },
        {
            title: '备注',
            width: 300,
            align: "center",
            dataIndex: 'note',
        },
        {
            align: "center",
            title: '操作',
            dataIndex: 'enable',
            render: (text, record) =>
                (
                    <Switch
                        checkedChildren="已启用"
                        unCheckedChildren="已禁用"
                        defaultChecked
                        checked={text === 1}
                        onChange={(v) => handleChangeStatus(v, record.id as string)}
                    />
                )
        },
    ];

    const onRow = (record: IVRMshelfDetail) => {
        console.log(record)
        let findArr = selectedShelfRows.find(item => item.id === record.id);
        if (findArr) {
            let filterArr = selectedShelfRows.filter(item => item.id !== record.id);
            setSelectedShelfRows(filterArr);
        } else {
            setSelectedShelfRows(origin => [...origin, record]);
        }
    };


    return (
        <>
            <YhBox action={action} >
                <Table
                    rowKey={record => record.id}
                    rowSelection={{
                        selectedRowKeys: selectedShelfRows.map(item => item.id), //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IVRMshelfDetail[]) => {
                            setSelectedShelfRows(selectedRows);
                        }
                    }}
                    columns={columns}
                    dataSource={shelfDataSource}
                    pagination={{
                        ...shelfPgCfg,
                        position: ["bottomCenter"],
                        showTotal: () => `共${shelfPgCfg.total}条`,
                        onChange: (pageNum, pageSize) => {
                            shelfLoadData({ pageNum, pageSize })
                        },
                        showSizeChanger: true
                    }}
                    bordered
                    onRow={record => ({
                        onClick: () => onRow(record)
                    })}
                    scroll={{ x: 'max-content' }}
                />
            </YhBox>
            <ShelfDrawer />
        </>
    )
}

